/*
 * Lalaba PDP template behaviors.
 * Used only by sections/lalaba-*.liquid — no impact on existing theme JS.
 */
(function () {
  'use strict';

  if (window.LalabaInitialized) return;
  window.LalabaInitialized = true;

  var moneyFormat = window.LalabaMoneyFormat || '{{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }

  /* ------------------------------------------------------------ accordion */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.llb-acc-trigger');
    if (!trigger) return;
    var item = trigger.closest('.llb-acc-item');
    var group = trigger.closest('.llb-accordion');
    var wasOpen = item.classList.contains('llb-open');
    if (group) {
      group.querySelectorAll('.llb-acc-item').forEach(function (i) {
        i.classList.remove('llb-open');
        var btn = i.querySelector('.llb-acc-trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
    if (!wasOpen) {
      item.classList.add('llb-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  /* ------------------------------------------------------------- quantity */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-llb-qty]');
    if (!btn) return;
    var wrap = btn.closest('.llb-qty');
    var input = wrap.querySelector('input');
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.llbQty, 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------- gallery thumbs */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.llb-pdp-thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.llb-pdp-gallery');
    setActiveMedia(gallery, thumb);
  });

  function setActiveMedia(gallery, thumb) {
    if (!gallery || !thumb) return;
    var main = gallery.querySelector('.llb-pdp-main-img img');
    var img = thumb.querySelector('img');
    if (main && img) {
      // Browsers ignore `src` while `srcset` is set, so swap srcset first
      // (or drop it when the thumb has none) before updating src.
      if (thumb.dataset.fullSrcset) {
        main.srcset = thumb.dataset.fullSrcset;
      } else {
        main.removeAttribute('srcset');
      }
      main.src = thumb.dataset.fullSrc || img.currentSrc || img.src;
      main.alt = thumb.dataset.mediaLabel || img.alt || '';
    }
    var label = gallery.querySelector('.llb-img-label');
    if (label && thumb.dataset.mediaLabel) label.textContent = thumb.dataset.mediaLabel;
    gallery.querySelectorAll('.llb-pdp-thumb').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
    scrollThumbIntoView(thumb);
  }

  /* ------------------------------------------------ thumb strip arrows */
  function thumbStep(strip) {
    var first = strip.querySelector('.llb-pdp-thumb');
    if (!first) return 0;
    var gap = parseFloat(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function updateThumbArrows(strip) {
    var wrap = strip.closest('.llb-pdp-thumbs-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('.llb-thumb-arrow--prev');
    var next = wrap.querySelector('.llb-thumb-arrow--next');
    var max = strip.scrollWidth - strip.clientWidth;
    var atStart = strip.scrollLeft <= 1;
    var atEnd = strip.scrollLeft >= max - 1;
    if (prev) prev.toggleAttribute('disabled', atStart);
    if (next) next.toggleAttribute('disabled', atEnd || max <= 0);
  }

  function scrollThumbIntoView(thumb) {
    var strip = thumb.closest('.llb-pdp-thumbs');
    if (!strip) return;
    var left = thumb.offsetLeft - strip.offsetLeft;
    var right = left + thumb.offsetWidth;
    if (left < strip.scrollLeft) {
      strip.scrollTo({ left: left, behavior: 'smooth' });
    } else if (right > strip.scrollLeft + strip.clientWidth) {
      strip.scrollTo({ left: right - strip.clientWidth, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-llb-thumb-nav]');
    if (!arrow) return;
    var strip = arrow.closest('.llb-pdp-thumbs-wrap').querySelector('.llb-pdp-thumbs');
    if (!strip) return;
    var dir = parseInt(arrow.dataset.llbThumbNav, 10) || 1;
    var cols = parseInt(getComputedStyle(strip.parentElement).getPropertyValue('--llb-thumb-cols'), 10) || 4;
    strip.scrollBy({ left: dir * thumbStep(strip) * cols, behavior: 'smooth' });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var strip = e.target.closest && e.target.closest('.llb-pdp-thumbs');
    if (!strip) return;
    e.preventDefault();
    strip.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * thumbStep(strip), behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var strip = e.target && e.target.classList && e.target.classList.contains('llb-pdp-thumbs') ? e.target : null;
      if (!strip) return;
      if (strip._llbRaf) return;
      strip._llbRaf = requestAnimationFrame(function () {
        strip._llbRaf = null;
        updateThumbArrows(strip);
      });
    },
    true
  );

  function initThumbStrips(root) {
    (root || document).querySelectorAll('.llb-pdp-thumbs').forEach(function (strip) {
      updateThumbArrows(strip);
      var active = strip.querySelector('.llb-pdp-thumb[aria-current="true"]');
      if (active) scrollThumbIntoView(active);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initThumbStrips(); });
  } else {
    initThumbStrips();
  }
  window.addEventListener('load', function () { initThumbStrips(); });
  window.addEventListener('resize', function () { initThumbStrips(); });
  document.addEventListener('shopify:section:load', function (e) { initThumbStrips(e.target); });

  /* -------------------------------------------------------- variant pills */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.llb-var-opt');
    if (!pill) return;
    var root = pill.closest('[data-llb-product]');
    if (!root) return;

    root.querySelectorAll('.llb-var-opt').forEach(function (p) {
      p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
    });

    var current = root.querySelector('.llb-var-current');
    if (current) current.textContent = pill.dataset.variantTitle;

    var idInput = root.querySelector('form [name="id"]');
    if (idInput) idInput.value = pill.dataset.variantId;

    // price
    var price = parseInt(pill.dataset.price, 10);
    var compare = parseInt(pill.dataset.comparePrice, 10) || 0;
    var priceEl = root.querySelector('.llb-price-main');
    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    var mrpEl = root.querySelector('.llb-price-mrp');
    var saveEl = root.querySelector('.llb-price-save');
    if (mrpEl) {
      if (compare > price) {
        mrpEl.textContent = formatMoney(compare);
        mrpEl.hidden = false;
      } else {
        mrpEl.hidden = true;
      }
    }
    if (saveEl) {
      if (compare > price) {
        saveEl.textContent = saveEl.dataset.savePrefix + ' ' + formatMoney(compare - price);
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    // availability
    var available = pill.dataset.available === 'true';
    var atc = root.querySelector('.llb-atc-main');
    if (atc) {
      atc.toggleAttribute('disabled', !available);
      var span = atc.querySelector('span');
      if (span) span.textContent = available ? atc.dataset.textAdd : atc.dataset.textSoldOut;
    }

    // sticky bar price
    var sticky = document.querySelector('.llb-sticky-atc');
    if (sticky) {
      var satPrice = sticky.querySelector('.llb-sat-price');
      if (satPrice && !isNaN(price)) satPrice.textContent = formatMoney(price);
      var satBtn = sticky.querySelector('.llb-sat-btn');
      if (satBtn) {
        satBtn.toggleAttribute('disabled', !available);
        satBtn.textContent = available ? satBtn.dataset.textAdd : satBtn.dataset.textSoldOut;
      }
    }

    // variant image
    if (pill.dataset.mediaPosition) {
      var gallery = root.querySelector('.llb-pdp-gallery');
      if (gallery) {
        var thumb = gallery.querySelector('.llb-pdp-thumb[data-media-position="' + pill.dataset.mediaPosition + '"]');
        if (thumb) setActiveMedia(gallery, thumb);
      }
    }

    // URL
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', pill.dataset.variantId);
      window.history.replaceState({}, '', url.toString());
    }
  });

  /* --------------------------------------------------- subscription toggle */
  document.addEventListener('click', function (e) {
    var offer = e.target.closest('.llb-sub-offer[data-selling-plan]');
    if (!offer) return;
    var root = offer.closest('[data-llb-product]');
    var input = root && root.querySelector('form [name="selling_plan"]');
    if (!input) return;
    var active = offer.getAttribute('aria-pressed') === 'true';
    offer.setAttribute('aria-pressed', active ? 'false' : 'true');
    input.disabled = active;
  });

  /* ------------------------------------------------------------- wishlist */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.llb-wishlist');
    if (!btn) return;
    var pressed = btn.getAttribute('aria-pressed') === 'true';
    btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    btn.textContent = pressed ? '♡' : '♥';
    try {
      var key = 'llb-wishlist';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      var handle = btn.dataset.productHandle;
      if (pressed) {
        list = list.filter(function (h) { return h !== handle; });
      } else if (list.indexOf(handle) === -1) {
        list.push(handle);
      }
      localStorage.setItem(key, JSON.stringify(list));
    } catch (err) {
      /* localStorage unavailable — visual toggle only */
    }
  });

  /* ------------------------------------------------------- delivery check */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.llb-delivery button');
    if (!btn) return;
    var wrap = btn.closest('.llb-delivery');
    var input = wrap.querySelector('input');
    var msg = wrap.parentElement.querySelector('.llb-delivery-msg');
    if (!msg) return;
    var pin = (input.value || '').trim();
    if (!/^\d{6}$/.test(pin)) {
      msg.textContent = msg.dataset.invalidText;
      msg.classList.add('llb-error');
      return;
    }
    var minDays = parseInt(wrap.dataset.minDays, 10) || 2;
    var maxDays = parseInt(wrap.dataset.maxDays, 10) || 6;
    var fmt = { day: 'numeric', month: 'short' };
    var from = new Date();
    from.setDate(from.getDate() + minDays);
    var to = new Date();
    to.setDate(to.getDate() + maxDays);
    msg.textContent = msg.dataset.successText
      .replace('[from]', from.toLocaleDateString(undefined, fmt))
      .replace('[to]', to.toLocaleDateString(undefined, fmt));
    msg.classList.remove('llb-error');
  });

  // Prevent Enter inside the PIN field from submitting any surrounding form
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('.llb-delivery')) {
      e.preventDefault();
      var btn = e.target.closest('.llb-delivery').querySelector('button');
      if (btn) btn.click();
    }
  });

  /* ----------------------------------------------------------- sticky bar */
  function initStickyBar() {
    var bar = document.querySelector('.llb-sticky-atc');
    if (!bar) return;
    var mainAtc = document.querySelector('.llb-pdp .llb-atc-main');
    var threshold = parseInt(bar.dataset.revealAfter, 10) || 600;

    function onScroll() {
      var show;
      if (mainAtc) {
        var rect = mainAtc.getBoundingClientRect();
        show = rect.bottom < 0;
      } else {
        show = window.scrollY > threshold;
      }
      bar.classList.toggle('llb-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var btn = bar.querySelector('.llb-sat-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var form = document.querySelector('.llb-pdp form[data-type="add-to-cart-form"]');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      });
    }
  }

  /* ---------------------------------------------------------------- toast */
  var toastTimer;
  function showToast() {
    var toast = document.querySelector('.llb-toast');
    if (!toast) return;
    toast.classList.add('llb-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('llb-visible');
    }, 3200);
  }

  function initToast() {
    // Only show our own toast when the theme has no cart drawer / notification
    var hasThemeCartUi =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (hasThemeCartUi) return;
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') showToast();
      });
    }
  }

  /* ---------------------------------------------------------- fade-up */
  function initFadeUp() {
    var faders = document.querySelectorAll('.llb-fade-up');
    if (!faders.length) return;
    if (!('IntersectionObserver' in window)) {
      faders.forEach(function (f) { f.classList.add('llb-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('llb-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    faders.forEach(function (f) { obs.observe(f); });
  }

  function init() {
    initStickyBar();
    initToast();
    initFadeUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Theme Editor section reloads
  document.addEventListener('shopify:section:load', function () {
    initFadeUp();
    initStickyBar();
  });
})();
